<template>
  <div class="text-center" style="background-color:black; padding-top:10px;">
    <h2 style="color:white;margin:10px;">实拍效果</h2>
     <p style="color:white;margin:10px;" class="small text-left">注：图片仅供参考，实际由于车型不同，中控和仪表盘设备硬件也不同，以及软件不断更新升级等原因，部分功能显示效果会有一些差异</p>
    <div class="">
      <img v-for="i in imageList" :src="i.imgUrl" :key="i.id" v-lazy="i.imgUrl" />
    </div>
    </div>
</template>

<script>
export default {
  name: "Effect",
  components: {},
  props: [],
  data() {
    return {
      baseUrl: process.env.BASE_URL,
      imageList: [],
    };
  },
  computed: {},
  created() {},
  mounted() {
    this.initFn();
  },
  methods: {
    //
    initFn() {
      this.imageList = [
        { id: "1", imgUrl: require("../assets/img/effect/sy_n1.jpg") },
        { id: "2", imgUrl: require("../assets/img/effect/sy_n2.jpg") },
        { id: "3", imgUrl: require("../assets/img/effect/sy_n5.jpg") },
        { id: "4", imgUrl: require("../assets/img/effect/sy_n3_1.jpeg") },
        { id: "5", imgUrl: require("../assets/img/effect/sy_n3_2.jpeg") },
        { id: "6", imgUrl: require("../assets/img/effect/hy0.jpg") },
        { id: "7", imgUrl: require("../assets/img/effect/hy2.jpg") },
        { id: "8", imgUrl: require("../assets/img/effect/crv1.jpg") },
        { id: "9", imgUrl: require("../assets/img/effect/hy1.jpg") },
        { id: "10", imgUrl: require("../assets/img/effect/gd1.jpg") },
        { id: "11", imgUrl: require("../assets/img/effect/gd_n1.jpg") },
        { id: "12", imgUrl: require("../assets/img/effect/gd4.jpeg") },
        { id: "13", imgUrl: require("../assets/img/effect/gd3.jpg") },
      ];
    },
  },
  watch: {},
  filters: {},
};
</script>
<style scoped>
img {
  width: auto;
  max-width: 100%;
}
</style>
